import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  props: ['fonteDeDados', 'disabled'],

  data () {
    return {
      paginas: [],
      opcoesDeRegistrosPorPagina: [10, 25, 50, 100]
    }
  },
  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    ...mapGetters('auth', ['opcaoMenuGestaoConta']),
    classBotaoAnterior () {
      return (this.fonteDeDados.paginaAtual > 1 && this.disabled === false) ? 'page-item' : 'page-item disabled'
    },
    classBotaoProximo () {
      return (this.fonteDeDados.paginaAtual < this.fonteDeDados.ultimaPagina && this.disabled === false) ? 'page-item' : 'page-item disabled'
    },
    contadorRegistros () {
      if (this.naoTemRegistros()) {
        return ''
      }
      const registroInicial = this.calcularRegistroInicial()
      const registroFinal = this.calcularRegistroFinal()
      const totalRegistros = this.fonteDeDados.totalRegistros
      return this.formatarContadorRegistros(registroInicial, registroFinal, totalRegistros)
    }
  },
  methods: {
    ...mapActions('pagination', ['ActionDefinirRegistrosPorPagina']),

    navegarNaPaginacao (evento, pagina, registrosPorPagina) {
      evento.preventDefault()
      this.ActionDefinirRegistrosPorPagina((registrosPorPagina !== null && registrosPorPagina !== undefined ? registrosPorPagina : this.registrosPorPagina))
      this.$emit('navegarNaPaginacao', pagina, this.registrosPorPagina)
    },
    tratarNavegacaoProximoEAnterior (evento, pagina) {
      let naoExisteProximoOuAnterior = (pagina === 0 || pagina === this.fonteDeDados.ultimaPagina + 1)

      if (naoExisteProximoOuAnterior) {
        return
      }

      this.navegarNaPaginacao(evento, pagina)
    },
    generatePagesArray: function (currentPage, collectionLength, rowsPerPage, paginationRange) {
      var pages = []
      var totalPages = Math.ceil(collectionLength / rowsPerPage)
      var halfWay = Math.ceil(paginationRange / 2)
      var position

      if (currentPage <= halfWay) {
        position = 'start'
      } else if (totalPages - halfWay < currentPage) {
        position = 'end'
      } else {
        position = 'middle'
      }

      var ellipsesNeeded = paginationRange < totalPages
      var i = 1
      while (i <= totalPages && i <= paginationRange) {
        var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages)
        var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'))
        var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'))
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          pages.push('...')
        } else {
          pages.push(pageNumber)
        }
        i++
      }
      return pages
    },

    calculatePageNumber: function (i, currentPage, paginationRange, totalPages) {
      var halfWay = Math.ceil(paginationRange / 2)
      if (i === paginationRange) {
        return totalPages
      } else if (i === 1) {
        return i
      } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return totalPages - paginationRange + i
        } else if (halfWay < currentPage) {
          return currentPage - halfWay + i
        } else {
          return i
        }
      } else {
        return i
      }
    },

    naoTemRegistros () {
      return this.fonteDeDados == null || this.fonteDeDados?.totalRegistros == null || this.fonteDeDados.totalRegistros === 0
    },

    calcularRegistroInicial () {
      const paginaAtual = this.fonteDeDados.paginaAtual
      const registrosPorPagina = this.obterRegistrosPorPagina()
      return ((paginaAtual - 1) * registrosPorPagina) + 1
    },

    calcularRegistroFinal () {
      const paginaAtual = this.fonteDeDados.paginaAtual
      const registrosPorPagina = this.obterRegistrosPorPagina()
      const totalRegistros = this.fonteDeDados.totalRegistros
      return Math.min(paginaAtual * registrosPorPagina, totalRegistros)
    },

    obterRegistrosPorPagina () {
      return this.fonteDeDados.registrosPorPagina || this.registrosPorPagina
    },

    formatarContadorRegistros (inicial, final, total) {
      return `Exibindo de ${inicial} a ${final} de ${total} registros`
    }
  },
  watch: {
    fonteDeDados () {
      let dados = this.fonteDeDados
      let quantidadeMaximaDePaginas = 10

      this.paginas = this.generatePagesArray(dados.paginaAtual, dados.totalRegistros, dados.registrosPorPagina, quantidadeMaximaDePaginas)
    }
  }
}
